import * as React from "react";
import { observer } from "mobx-react";
import { action, observable } from "mobx";
import LegalStore from "../../../stores/legalStore";
import SeekerStore from "../../../stores/SeekerStore";
import { ScreenMode } from "../../../models/enums";
import { Auth } from "../../../utils/auth";
import Button from "material-ui/Button";
import Checkbox from "material-ui/Checkbox";
import { FormGroup, FormControlLabel } from 'material-ui/Form';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle } from "material-ui/Dialog";
import Close from "material-ui-icons/Close";
import IconButton from "material-ui/IconButton";
import { Row, Col } from "react-flexbox-grid";

@observer
export default class TermsAndConditionsDlg extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  setAgrees = (agrees: boolean): void => {
    this.props.store.legal.setAcceptTerms(agrees ? 2 : 1);
  }
  render(): JSX.Element {
    const agrees: boolean = this.props.store.legal.acceptTerms === 2;
    const ls: LegalStore = this.props.store.legal;
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const stylesBtn: any = ({
      MuiIconButton: {
        color: "#5B6770",
      },
      icon: {
        height: "28px",
        width: "28px",
      }
    });
    return <Dialog
      open={this.props.store.legal.showTerms}
      aria-labelledby="responsive-dialog-title"
      fullScreen={mode === ScreenMode.Mobile} >
      <DialogTitle><Row middle="xs">
        <Col xs={10}>
          {this.props.store.localization.fields.legalDlg.title}
        </Col>
        <Col xs={2}>
          <IconButton style={stylesBtn.MuiIconButton} aria-label="close" onClick={() => this.props.store.legal.hideTermsAndConditions()}><Close style={stylesBtn.icon} /></IconButton>
        </Col>
      </Row></DialogTitle>     
      <DialogContent>       
        <DialogContentText>
          <div dangerouslySetInnerHTML={{ __html: ls.termsText}}></div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={() => this.props.store.legal.hideTermsAndConditions()} >{this.props.store.localization.fields.close}</Button>
      </DialogActions>
      </Dialog>
  }
}


// WEBPACK FOOTER //
// ./src/components/dialogs/termsAndConditions/index.tsx